import { Granularity } from 'bindings/time/Granularity';
import chartImage from 'images/icons/chart.svg';
import * as React from 'react';
import { useRecoilState } from 'recoil';
import { AGranularitySelect } from '../../../atoms/filter/timeFilterAtom';
import { ReportFiltersContext } from '../../../containers_v2/reports/generic/generic';
import { translateToString } from '../../../styles/global/translate';
import Dropdown from '../../dropdown/Dropdown';
import { DropdownData, DropdownStyle } from '../../dropdown/model/Model';
import { DROPDOWN_FILTER_STYLE } from '../brands/BrandFilter';
import { GenericToolbarFilterProps } from '../ToolbarFilter';

export const ALL_GRANULARITY: Granularity[] = [
	'day',
	'week',
	'month',
	'quarter',
	// 'fourMonth',
	'year'
];

export default function GranularitySelect(
	props: {style?: DropdownStyle, noIcon?: boolean, granularityHook?: [Granularity, React.Dispatch<React.SetStateAction<Granularity>>], availableGranularities?: Granularity[] } & GenericToolbarFilterProps
): JSX.Element {
	const { filters, setFilters } = React.useContext(ReportFiltersContext);
	const [granularity, setGranularity] = props.granularityHook ?? useRecoilState(AGranularitySelect);
	if (props.hidden) return <></>;

	let localGranularity;
	if (props.context) {
		localGranularity = filters.evolution;
		if (localGranularity === undefined) {
			localGranularity = 'month';
		}
	} else {
		localGranularity = granularity;
	}

	return (
		<Dropdown
			searchable={false}
			dropdownStyle={props.style ?? {
				...DROPDOWN_FILTER_STYLE,
				width: props.fullScreen ? '100%' : DROPDOWN_FILTER_STYLE.width,
				containerWidth: props.fullScreen
					? '100%'
					: DROPDOWN_FILTER_STYLE.containerWidth
			}}
			readOnly
			selectedValue={{
				label: translateToString(localGranularity),
				value: localGranularity,
				color: 'transparent'
			}}
			datalist={(props.availableGranularities ?? ALL_GRANULARITY).map(g => ({
				label: translateToString(g),
				value: g,
				color: 'transparent'
			}))}
			name="dropdown_granularity_filter"
			onChange={(value: DropdownData<Granularity>) => {
				if (props.context) {
					setFilters(filters => ({ ...filters, evolution: value.value }));
				} else {
					setGranularity(value.value);
				}
			}}
			image={props.noIcon ? undefined : chartImage}
		/>
	);
}
